// The CRM surface owning an object's detail, by the type names timeline links and Luci citations
// share. A type with no entry renders as plain text rather than a dead link.
export interface MemberIds {
  patientId: number | null
  personId: number
}

type BuildPath = (objectId: number, member: MemberIds) => string | null

// A tab the nav shows only for a patient account.
const patientTab =
  (tab: string): BuildPath =>
  (_objectId, { patientId }) =>
    patientId == null ? null : `/patients/${patientId}/${tab}`

// A tab the nav shows in person mode too, reached through the person when there is no account.
const personTab =
  (tab: string): BuildPath =>
  (_objectId, { patientId, personId }) =>
    patientId == null ? `/people/${personId}/${tab}` : `/patients/${patientId}/${tab}`

const SURFACE_PATHS: Record<string, BuildPath> = {
  appointment: patientTab('appointments'),
  care_plan: patientTab('careplans'),
  form: patientTab('forms'),
  form_submission: patientTab('forms'),
  case: objectId => `/cases/${objectId}`,
  task: personTab('todos'),
  steerage: personTab('navigation'),
  prior_authorization: personTab('priorauthorization'),
  claim: personTab('claims'),
  accumulator: personTab('accumulators'),
  policy_document_chunk: personTab('benefit-documents'),
  measure_report: personTab('care-gaps'),
  medication: personTab('medications'),
  emergency_encounter: personTab('zap'),
}

/** Null without a surface for the type, or when the surface needs a patient account and there is none. */
export const memberSurfacePath = (
  objectType: string,
  objectId: number,
  member: MemberIds,
): string | null => {
  const buildPath = SURFACE_PATHS[objectType]
  return buildPath ? buildPath(objectId, member) : null
}
